// Rahmen Definition アルファベット順記述
import controls from '@/rahmen/controls'
import d2fmt from '@/ddv2.library/utils/formatter'
import dayjs from 'dayjs'
import filter from '@/rahmen/utils/filters'
import flowMixin from '@/mixins/flowMixins'
import header from '@/ddv2.library/header'
import indexeddb from '@/ddv2.library/indexeddb'
import message from '@/ddv2.library/messages'
import modals from '@/ddv2.library/modals'
import validators from '@/rahmen/validators'
// import tax from '@/ddv2.library/tax'

// vue Definition
import { mapGetters } from 'vuex'

// DdComponents アルファベット順記述
const DdCheckbox = () => import('@/components/DdCheckbox')
const DdCodeTextBox = () => import('@/components/DdCodeTextBox')
const DdCodeTextBoxSwitching = () => import('@/components/DdCodeTextBoxSwitching')
const DdCustomButton = () => import('@/components/DdCustomButton')
const DdDateBox = () => import('@/components/DdDateBox')
const DdDropDown = () => import('@/components/DdDropDown')
const DdIconButtonWithTooltip = () => import('@/components/DdIconButtonWithTooltip')
const DdNumericBox = () => import('@/components/DdNumericBox')
const DdRadioButton = () => import('@/components/DdRadioButton')
const DdSectionTitle = () => import('@/components/DdSectionTitle')
const DdTeikeiCorseSearchTextBox = () => import('@/components/DdTeikeiCorseSearchTextBox')
const DdTextArea = () => import('@/components/DdTextArea')
const DdTextBox = () => import('@/components/DdTextBox')
const DdTextBoxSwitching = () => import('@/components/DdTextBoxSwitching')
const DdTimeBox = () => import('@/components/DdTimeBox')

export default {
  name: 'DdHaishaJuchuEditDialog',
  mixins: [flowMixin],

  // 参照コンポーネント定義
  components: {
    DdCheckbox,
    DdCodeTextBox,
    DdCodeTextBoxSwitching,
    DdCustomButton,
    DdDateBox,
    DdDropDown,
    DdIconButtonWithTooltip,
    DdNumericBox,
    DdRadioButton,
    DdSectionTitle,
    DdTeikeiCorseSearchTextBox,
    DdTextArea,
    DdTextBox,
    DdTextBoxSwitching,
    DdTimeBox
  },

  // プロパティ定義
  props: {
    /**
     * 表示状態
     */
    showDialog: Boolean,
    /**
     * 受注情報構造体
     */
    dataSource: Object,
    /**
    * 読取モード
    */
    readOnly: {
      type: Boolean,
      default: false
    },
    /**
    * 時刻必須モード
    */
    isRequiredHms: {
      type: Boolean,
      default: false
    },
    /**
    * 配車年月日
    */
    unkoYmd: {
      type: String,
      default: filter.dateFormatter(new Date())
    }
  },

  data: () => ({
    invalidMessage: '',
    // ヘッダー定義
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    mstHacchakuchiHeaders: header.mstHacchakuchiHeaders,
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    // 戻り値用定義
    vwCD2plmd00101: {},
    tempVwCD2plmd00101: {},
    /*
    rec: {
      id: 0,
      juchuNo: '',
      juchuYmd: '',
      juchuEigyosho: '',
      chumonNo: '',
      sagyoYoteiYmd: '',
      sagyoEigyosho: '',
      tokuisaki: '',
      hatsuchiYmd: '',
      hatsuchiHms: '',
      hatsuHmsFixed: false,
      oroshisaki: '',
      chakuchiYmd: '',
      chakuchiHms: '',
      chakuHmsFixed: false,
      chipColor: ''
    },
    */
    seikyuGokeiAmount: 0,
    // 作業変数定義
    colorDialog: false,
    chipColorTmp: '',
    expandKeiyuchi: false,
    // 表示制御
    baseSectionCol: 12,
    selectNinushiCd: '',
    hatsuchiSwitch: false,
    chakuchiSwitch: false,
    switchReadonly: false,
    newEditMode: false,
    continuousSaveMode: false,
    saveCount: 0,
    modeKengen: 0
  }),

  created () {
    this.initialize()
  },

  mounted () {
    const dtl = controls.getInputTypeDetail(this.valueType)
    if (!dtl) { return }
    this.invalidMessage = this.errorMessages
    console.log('mounted', this.invalidMessage, this.$el)
  },

  watch: {
    showDialog: function (n) {
      if (n === true) {
        this.initBindVariables()
      }
    }
    /*
    'rec.juchuYmd': function (n) {
      if (this.rec.sagyoYoteiYmd === '') {
        this.rec.sagyoYoteiYmd = n
      }
      if (this.rec.hatsuchiYmd === '') {
        this.rec.hatsuchiYmd = n
      }
      if (this.rec.chakuchiYmd === '') {
        this.rec.chakuchiYmd = n
      }
    },
    'rec.juchuEigyosho': function (n) {
      if (this.rec.sagyoEigyosho === '') {
        this.rec.sagyoEigyosho = this.rec.juchuEigyosho
      }
    }
    */
  },

  /* **************************************************************************************************** *
   *
   * 算出プロパティ
   *
   * **************************************************************************************************** */
  computed: {
    // --------------------------------------------------------------------------------
    // Indexed DB データ
    // --------------------------------------------------------------------------------
    ...mapGetters({
      eigyoshoList: 'DDMasters/mstEigyosho',
      teikeiCourseList: 'DDMasters/vwCD2mstd0370',
      hacchakuchiList: 'DDMasters/mstHacchakuchi',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      shubetsuList: 'DDMasters/mstShubetsu',
      kubunList: 'DDMasters/msysKubun',
      eigyoshoJininList: 'DDMasters/vwCMstEigyoshoJininList',
      sharyoList: 'DDMasters/vwCMstSharyo',
      currentKaishaCode: 'users/currentKaishaCode',
      usersEigyosho: 'users/eigyoshoCd'
    }),

    // --------------------------------------------------------------------------------
    // フィルター
    // --------------------------------------------------------------------------------
    filteredEigyoshoListExcludes99 () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn !== '03' & elem.eigyoshoCd !== '99'
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.eigyoshoCd > elem2.eigyoshoCd) { return 1 }
        if (elem1.eigyoshoCd === elem2.eigyoshoCd) { return 0 }
        return -1
      })
    },
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn !== '03'
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.eigyoshoCd > elem2.eigyoshoCd) { return 1 }
        if (elem1.eigyoshoCd === elem2.eigyoshoCd) { return 0 }
        return -1
      })
    },
    filteredMstTorihikisaki () {
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    filteredMstTokuisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.tokuisakiFlg === true
      })
    },
    filteredHacchakuchiList () {
      const self = this
      return self.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return self.hacchakuchiFilter(elem)
      })
    },
    filteredHacchakuchiListLite () {
      if (!this.expandKeiyuchi) {
        return []
      }

      const self = this
      return self.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return self.hacchakuchiFilter(elem)
      })
    },
    filteredTeikeiCourseList () {
      return this.teikeiCourseList.map((elem) => {
        if (elem.ninushiId) { elem.ninushiDisp = elem.ninushiCd + ' : ' + elem.ninushiNm }
        if (elem.hatsuchiId) { elem.hatsuchiDisp = elem.hatsuchiCd + ' : ' + elem.hatsuchiNm }
        if (elem.chakuchiId) { elem.chakuchiDisp = elem.chakuchiCd + ' : ' + elem.chakuchiNm }
        if (elem.keiyuchiId1) { elem.keiyuchiId1Disp = elem.keiyuchiId1Cd + ' : ' + elem.keiyuchiId1Nm }
        if (elem.keiyuchiId2) { elem.keiyuchiId2Disp = elem.keiyuchiId2Cd + ' : ' + elem.keiyuchiId2Nm }
        if (elem.keiyuchiId3) { elem.keiyuchiId3Disp = elem.keiyuchiId3Cd + ' : ' + elem.keiyuchiId3Nm }
        if (elem.keiyuchiId4) { elem.keiyuchiId4Disp = elem.keiyuchiId4Cd + ' : ' + elem.keiyuchiId4Nm }
        if (elem.keiyuchiId5) { elem.keiyuchiId5Disp = elem.keiyuchiId5Cd + ' : ' + elem.keiyuchiId5Nm }
        if (elem.tantoEigyoshoId) { elem.tantoEigyoshoDisp = elem.tantoEigyoshoCd + ' : ' + elem.tantoEigyoshoNm }
        if (elem.hacchusakiId) { elem.hacchusakiDisp = elem.hacchusakiCd + ' : ' + elem.hacchusakiNm }
        if (elem.hatsuchiHms) { elem.hatsuchiHms = (elem.hatsuchiHms).slice(0, 5) }
        if (elem.chakuchiHms) { elem.chakuchiHms = (elem.chakuchiHms).slice(0, 5) }
        if (elem.seikyuKihonUnchin) { elem.seikyuKihonUnchin = filter.numericFormatter(elem.seikyuKihonUnchin) }
        if (elem.seikyuTsukoryo) { elem.seikyuTsukoryo = filter.numericFormatter(elem.seikyuTsukoryo) }
        if (elem.seikyuKingaku1) { elem.seikyuKingaku1 = filter.numericFormatter(elem.seikyuKingaku1) }
        if (elem.seikyuKingaku2) { elem.seikyuKingaku2 = filter.numericFormatter(elem.seikyuKingaku2) }
        if (elem.seikyuGokei) { elem.seikyuGokei = filter.numericFormatter(elem.seikyuGokei) }
        elem.startLockFlgDisp = elem.startLockFlg ? '〇' : ''
        elem.endLockFlgDisp = elem.endLockFlg ? '〇' : ''
        elem.hacchusakiFlgDisp = elem.hacchusakiFlg ? '〇' : ''
        return elem
      })
    },
    // 貨物区分フィルター
    filteredKamotsuShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SBT025')
    },
    // 車種フィルター
    filteredSharyoShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVI011')
    },
    // 運賃計算方法区分フィルター
    filteredUnchinKeisanKbnList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFF055')
    },
    dispCreateButton () {
      return this.modeKengen !== 0
    },
    dispDeleteButton () {
      console.log('dispDeleteButton', this.modeKengen, this.vwCD2plmd00101.id)
      return this.modeKengen === 2 && this.vwCD2plmd00101.id !== 'NEW' && this.vwCD2plmd00101.id !== -1
    },
    readOnlyMode () {
      return this.readOnly || this.vwCD2plmd00101.kakuteiFlg
    }
  },
  /* **************************************************************************************************** *
   *
   * メソッド
   *
   * **************************************************************************************************** */
  methods: {
    initialize () {
      console.log('initialize')
      const self = this
      const option = {
        loadMasters: [],
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.initBindVariables()
            resolve()
          })
        },
        savedInputRestorePromise: function (c) {
          return new Promise((resolve) => {
            // ユーザ保存項目の復元
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              this.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              this.modeKengen = 1
            } else {
              // フルアクセス
              this.modeKengen = 2
            }
            // thisId == 0 then 新規モード
            if (this.id === 0) {
              this.modeOfEdit = 0 // 新規モード
            } else if (this.modeKengen === 0) {
              this.modeOfEdit = 1 // 照会モード
            } else {
              this.modeOfEdit = 2 // 更新モード
            }
            resolve()
          })
        },
        settingLoadEffect: function () {
          return true
        }
      }
      this.initializeForRegister(option)
    },
    // --------------------------------------------------------------------------------
    // 初期値設定
    // --------------------------------------------------------------------------------
    initBindVariables: function () {
      this.continuousSaveMode = false
      this.seikyuGokeiAmount = 0
      this.baseSectionCol = 12
      this.clearInvalidMessage(this.$refs)
      this.chipColorTmp = '#00FF00'
      this.saveCount = 0
      if ((this.dataSource) && this.dataSource !== null) {
        var initVwCD2plmd00101 = Object.assign({}, this.dataSource)

        if (initVwCD2plmd00101.id === 'NEW') {
          const today = filter.dateFormatter(new Date())
          const miwariateEigyoshoInfo = indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoList, 'eigyoshoCd', '99', today)
          this.selectNinushiCd = ''
          this.baseSectionCol = 10
          this.newEditMode = true
          this.hatsuchiSwitch = false
          this.chakuchiSwitch = false
          this.switchReadonly = true
          this.expandKeiyuchi = false
          initVwCD2plmd00101 = {
            ...initVwCD2plmd00101,
            kakuteiFlg: false,
            juchuYmd: today,
            juchuEigyoshoId: indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoList, 'eigyoshoCd', this.usersEigyosho, today).id,
            sagyoYmd: this.unkoYmd,
            sagyoEigyoshoId: miwariateEigyoshoInfo ? miwariateEigyoshoInfo.id : null,
            ninushiId: null,
            teikeiCourseNo: null,
            keiyakuHojoKbn: '1',
            startLockFlg: true,
            hatsuchiId: null,
            keiyuchiId1: null,
            keiyuchiId2: null,
            keiyuchiId3: null,
            keiyuchiId4: null,
            keiyuchiId5: null,
            chakuchiId: null,
            chakuchiYmd: initVwCD2plmd00101.hatsuchiYmd,
            seikyuYoteiYmd: initVwCD2plmd00101.hatsuchiYmd,
            endLockFlg: false,
            shujitsuFlg: false
          }
        } else if (initVwCD2plmd00101.id) {
          this.newEditMode = false
          this.chipColorTmp = initVwCD2plmd00101.color
          this.selectNinushiCd = indexeddb.getRecord(this.torihikisakiList, initVwCD2plmd00101.ninushiId).torihikisakiCd
          initVwCD2plmd00101.trJuchuMeisaiInsDateTime = filter.dateYmdHmsFormatter(initVwCD2plmd00101.trJuchuMeisaiInsDate)
          var iUser = indexeddb.getRecord(this.eigyoshoJininList, initVwCD2plmd00101.trJuchuMeisaiInsUserId)
          if (iUser) {
            initVwCD2plmd00101.trJuchuMeisaiInsUserCdNm = iUser.jininCd + ':' + iUser.jininNmSei
          }
          initVwCD2plmd00101.trJuchuMeisaiUpdDateTime = filter.dateYmdHmsFormatter(initVwCD2plmd00101.trJuchuMeisaiUpdDate)
          var uUser = indexeddb.getRecord(this.eigyoshoJininList, initVwCD2plmd00101.trJuchuMeisaiUpdUserId)
          if (uUser) {
            initVwCD2plmd00101.trJuchuMeisaiUpdUserCdNm = uUser.jininCd + ':' + uUser.jininNmSei
          }
          initVwCD2plmd00101.kakuteiFlg = this.isRequiredHms ? initVwCD2plmd00101.kakuteiFlg : false
        }
        this.vwCD2plmd00101 = Object.assign({}, initVwCD2plmd00101)
        this.tempVwCD2plmd00101 = Object.assign({}, this.vwCD2plmd00101)
        this.dispSwitchControl()
        this.calcSeikyuGokeiAmount()
        initVwCD2plmd00101 = undefined
      }
    },
    // ----------------------------------------------------------------------------------------------------
    // 取引先マスタ項目設定情報取得
    // ----------------------------------------------------------------------------------------------------
    // 荷主IDが入力されたら、取引先マスタ設定情報を取得メソッドを呼ぶ
    changeNinushi: function () {
      if (!this.vwCD2plmd00101.ninushiId) {
        this.selectNinushiCd = ''
        return
      }
      this.getTorihikisakiInfo(this.vwCD2plmd00101.ninushiId)
    },
    getTorihikisakiInfo: function () {
      return new Promise((resolve) => {
        this.HttpClient
          .get(`/api/v1/VwCD2plmd00101/MstTorihikisakiInfoFind?id=${this.vwCD2plmd00101.ninushiId}`)
          .then((data) => {
            const initVwCD2plmd00101 = Object.assign({}, this.vwCD2plmd00101)
            initVwCD2plmd00101.color = data.payload.color ?? '#00FF00'
            this.chipColorTmp = initVwCD2plmd00101.color
            this.selectNinushiCd = indexeddb.getRecord(this.torihikisakiList, initVwCD2plmd00101.ninushiId).torihikisakiCd
            initVwCD2plmd00101.keijobiKbn = data.payload.keijobiKbn ?? '1'
            initVwCD2plmd00101.unchinHasuKeisanKbn = data.payload.unchinHasuKeisanKbn ?? '02'
            initVwCD2plmd00101.keijobiKbn === '1' ? this.$set(initVwCD2plmd00101, 'seikyuYoteiYmd', initVwCD2plmd00101.hatsuchiYmd) : this.$set(initVwCD2plmd00101, 'seikyuYoteiYmd', initVwCD2plmd00101.chakuchiYmd)
            this.vwCD2plmd00101 = Object.assign({}, initVwCD2plmd00101)
          })
        resolve()
      })
    },
    hacchakuchiFilter (elem) {
      const self = this
      const target = filter.dateFormatter(new Date())
      return (elem.tekiyoStartYmdDisp <= target) &&
            (elem.tekiyoEndYmdDisp >= target) &&
            (!self.selectNinushiCd || (elem.torihikisakiCd === self.selectNinushiCd || elem.torihikisakiCd === null))
    },
    // 反映ボタン押下時
    teikeiCourseNoSync: function () {
      if (!this.vwCD2plmd00101.teikeiCourseNo) { return }
      var teikeiInfo = this.getTeikeiInfo(this.vwCD2plmd00101.teikeiCourseNo)
      this.teikeiCourseNoDialogSync(teikeiInfo)
    },
    // ポップアップから選択時
    teikeiCourseNoDialogSync: function (elem) {
      var initVwCD2plmd00101 = Object.assign({}, this.vwCD2plmd00101)
      this.hatsuchiSwitch = false
      this.chakuchiSwitch = false
      this.switchReadonly = true
      initVwCD2plmd00101 = {
        ...initVwCD2plmd00101,
        keiyakuHojoKbn: '1',
        ninushiId: elem.ninushiId,
        chumonNo: elem.chumonNo,
        sagyoEigyoshoId: elem.tantoEigyoshoId,
        hatsuchiId: elem.hatsuchiId,
        startLockFlg: elem.startLockFlg,
        keiyuchiId1: elem.keiyuchiId1,
        keiyuchiId1Biko: elem.keiyuchiId1Biko,
        keiyuchiId2: elem.keiyuchiId2,
        keiyuchiId2Biko: elem.keiyuchiId2Biko,
        keiyuchiId3: elem.keiyuchiId3,
        keiyuchiId3Biko: elem.keiyuchiId3Biko,
        keiyuchiId4: elem.keiyuchiId4,
        keiyuchiId4Biko: elem.keiyuchiId4Biko,
        keiyuchiId5: elem.keiyuchiId5,
        keiyuchiId5Biko: elem.keiyuchiId5Biko,
        chakuchiId: elem.chakuchiId,
        endLockFlg: elem.endLockFlg,
        unchinKeisanKbn: elem.seikyuUnchinKeisanKbn,
        kamotsuKbn: elem.kamotsuKbn,
        seikyuShashuSbt: elem.seikyuShashuSbt,
        hatsuchiHms: elem.hatsuchiHms,
        chakuchiHms: elem.chakuchiHms,
        kihonUnchin: d2fmt.removeComma(elem.seikyuKihonUnchin),
        hiwayPrice: d2fmt.removeComma(elem.seikyuTsukoryo),
        userKingakuKazei1: d2fmt.removeComma(elem.seikyuKingaku1),
        userKingakuKazei2: d2fmt.removeComma(elem.seikyuKingaku2),
        renrakuBiko: elem.renrakuBiko
      }
      var data = {}
      const target = filter.dateFormatter(new Date())
      if (initVwCD2plmd00101.ninushiId) {
        data = indexeddb.getRecord(this.torihikisakiList, initVwCD2plmd00101.ninushiId)
        if (data.tekiyoStartYmd > target || data.tekiyoEndYmd < target) {
          initVwCD2plmd00101.ninushiId = null
        }
      }
      if (initVwCD2plmd00101.hatsuchiId) {
        data = indexeddb.getRecord(this.hacchakuchiList, initVwCD2plmd00101.hatsuchiId)
        if (data.tekiyoStartYmd > target || data.tekiyoEndYmd < target) {
          initVwCD2plmd00101.hatsuchiId = null
        }
      }
      if (initVwCD2plmd00101.keiyuchiId1) {
        data = indexeddb.getRecord(this.hacchakuchiList, initVwCD2plmd00101.keiyuchiId1)
        if (data.tekiyoStartYmd > target || data.tekiyoEndYmd < target) {
          initVwCD2plmd00101.keiyuchiId1 = null
        }
      }
      if (initVwCD2plmd00101.keiyuchiId2) {
        data = indexeddb.getRecord(this.hacchakuchiList, initVwCD2plmd00101.keiyuchiId2)
        if (data.tekiyoStartYmd > target || data.tekiyoEndYmd < target) {
          initVwCD2plmd00101.keiyuchiId2 = null
        }
      }
      if (initVwCD2plmd00101.keiyuchiId3) {
        data = indexeddb.getRecord(this.hacchakuchiList, initVwCD2plmd00101.keiyuchiId3)
        if (data.tekiyoStartYmd > target || data.tekiyoEndYmd < target) {
          initVwCD2plmd00101.keiyuchiId3 = null
        }
      }
      if (initVwCD2plmd00101.keiyuchiId4) {
        data = indexeddb.getRecord(this.hacchakuchiList, initVwCD2plmd00101.keiyuchiId4)
        if (data.tekiyoStartYmd > target || data.tekiyoEndYmd < target) {
          initVwCD2plmd00101.keiyuchiId4 = null
        }
      }
      if (initVwCD2plmd00101.keiyuchiId5) {
        data = indexeddb.getRecord(this.hacchakuchiList, initVwCD2plmd00101.keiyuchiId5)
        if (data.tekiyoStartYmd > target || data.tekiyoEndYmd < target) {
          initVwCD2plmd00101.keiyuchiId5 = null
        }
      }
      if (initVwCD2plmd00101.chakuchiId) {
        data = indexeddb.getRecord(this.hacchakuchiList, initVwCD2plmd00101.chakuchiId)
        if (data.tekiyoStartYmd > target || data.tekiyoEndYmd < target) {
          initVwCD2plmd00101.chakuchiId = null
        }
      }
      if (initVwCD2plmd00101.hatsuchiYmd && initVwCD2plmd00101.hatsuchiHms && initVwCD2plmd00101.chakuchiHms && initVwCD2plmd00101.hatsuchiHms > initVwCD2plmd00101.chakuchiHms) {
        initVwCD2plmd00101.chakuchiYmd = filter.dateFormatter(dayjs(initVwCD2plmd00101.hatsuchiYmd).add(1, 'd'))
      }
      this.vwCD2plmd00101 = Object.assign({}, initVwCD2plmd00101)
      initVwCD2plmd00101 = undefined
      this.dispSwitchControl()
      this.calcSeikyuGokeiAmount()
    },
    // 請求合計金額算出
    calcSeikyuGokeiAmount: function () {
      let amount = 0

      let seikyuUnchin = this.vwCD2plmd00101.kihonUnchin ?? '0'
      let seikyuTsukoryo = this.vwCD2plmd00101.hiwayPrice ?? '0'
      let seikyuKingaku1 = this.vwCD2plmd00101.userKingakuKazei1 ?? '0'
      let seikyuKingaku2 = this.vwCD2plmd00101.userKingakuKazei2 ?? '0'

      if (this.vwCD2plmd00101.kihonUnchin === undefined || this.vwCD2plmd00101.kihonUnchin === '') { seikyuUnchin = '0' }
      if (this.vwCD2plmd00101.hiwayPrice === undefined || this.vwCD2plmd00101.hiwayPrice === '') { seikyuTsukoryo = '0' }
      if (this.vwCD2plmd00101.userKingakuKazei1 === undefined || this.vwCD2plmd00101.userKingakuKazei1 === '') { seikyuKingaku1 = '0' }
      if (this.vwCD2plmd00101.userKingakuKazei2 === undefined || this.vwCD2plmd00101.userKingakuKazei2 === '') { seikyuKingaku2 = '0' }

      const seikyuKazeiAmount = parseInt(seikyuUnchin, 10) + parseInt(seikyuKingaku1, 10) + parseInt(seikyuKingaku2, 10)

      /*
      const hasuKeisanKbn = this.vwCD2plmd00101.unchinHasuKeisanKbn ? this.vwCD2plmd00101.unchinHasuKeisanKbn : '02'

      if (seikyuKazeiAmount > 0) {
        seikyuKazeiAmount = tax.calcTaxToIncluded(seikyuKazeiAmount, hasuKeisanKbn, new Date())
      }
      */
      amount = seikyuKazeiAmount + parseInt(seikyuTsukoryo, 10)

      this.seikyuGokeiAmount = amount
    },
    // --------------------------------------------------------------------------------
    // 閉じるボタン押下
    // --------------------------------------------------------------------------------
    onCloseClick: function (e) {
      this.$emit('close', undefined)
    },
    // --------------------------------------------------------------------------------
    // キャンセルボタン押下
    // --------------------------------------------------------------------------------
    onCancelClick: function (e) {
      const p = modals.showConfirm
      p('COMQ0006').then((ok) => {
        if (ok === false || ok === undefined) { return }
        this.Effects.loadStart()
        this.vwCD2plmd00101 = Object.assign({}, this.tempVwCD2plmd00101)
        this.dispSwitchControl()
        this.Effects.loadComplete()
      })
    },
    // --------------------------------------------------------------------------------
    // 削除ボタン押下
    // --------------------------------------------------------------------------------
    onDeleteClick: function (e) {
      const self = this
      const opt = {
        deleteRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCD2plmd00101/JuchuDelete', self.vwCD2plmd00101).then(data => {
              resolve(data)
            })
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        getSavedInputMethod: function () {
          return {}
        },
        settingReloadWindow: function () {
          return true
        },
        isInvokeCallbackOnSuccess: function () {
          return true
        },
        onSuccessCallback: function () {
          return new Promise(resolve => {
            self.$emit('delete', self.vwCD2plmd00101)
            resolve()
          })
        }
      }
      this.delete(opt)
    },
    deleteValidate: function () {
      return true
    },
    onContinuousSaveClick: function (e) {
      this.continuousSaveMode = true
      this.onSaveClick()
    },
    // --------------------------------------------------------------------------------
    // 保存ボタン押下
    // --------------------------------------------------------------------------------
    onSaveClick: function (e) {
      // /* eslint no-debugger: "warn" */
      // debugger
      const initVwCD2plmd00101 = Object.assign({}, this.vwCD2plmd00101)
      if (initVwCD2plmd00101.sagyoEigyoshoId !== '') {
        var mstEigyosho = indexeddb.getRecord(this.eigyoshoList, initVwCD2plmd00101.sagyoEigyoshoId)
        if (mstEigyosho) {
          initVwCD2plmd00101.sagyoEigyoshoCd = mstEigyosho.eigyoshoCd
          initVwCD2plmd00101.sagyoEigyoshoNm = mstEigyosho.eigyoshoNm
        }
      }
      if (initVwCD2plmd00101.ninushiId !== '') {
        var mstNinushi = indexeddb.getRecord(this.torihikisakiList, initVwCD2plmd00101.ninushiId)
        if (mstNinushi) {
          initVwCD2plmd00101.ninushiCd = mstNinushi.torihikisakiCd
          initVwCD2plmd00101.ninushiNm = mstNinushi.torihikisakiNm
        }
      }
      if (initVwCD2plmd00101.oroshisakiId !== '') {
        var mstOroshisaki = indexeddb.getRecord(this.torihikisakiList, initVwCD2plmd00101.oroshisakiId)
        if (mstOroshisaki) {
          initVwCD2plmd00101.oroshisakiCd = mstOroshisaki.torihikisakiCd
          initVwCD2plmd00101.oroshisakiNm = mstOroshisaki.torihikisakiNm
        }
      }
      if (initVwCD2plmd00101.hatsuchiId !== '') {
        var mstHatsuchi = indexeddb.getRecord(this.hacchakuchiList, initVwCD2plmd00101.hatsuchiId)
        if (mstHatsuchi) {
          initVwCD2plmd00101.hatsuchiCd = mstHatsuchi.hacchakuchiCd
          initVwCD2plmd00101.hatsuchiNm = mstHatsuchi.hacchakuchiNm
        }
      }
      if (initVwCD2plmd00101.chakuchiId !== '') {
        var mstChakuchi = indexeddb.getRecord(this.hacchakuchiList, initVwCD2plmd00101.chakuchiId)
        if (mstChakuchi) {
          initVwCD2plmd00101.chakuchiCd = mstChakuchi.hacchakuchiCd
          initVwCD2plmd00101.chakuchiNm = mstChakuchi.hacchakuchiNm
        }
      }
      if (initVwCD2plmd00101.id === 'NEW') {
        initVwCD2plmd00101.id = -1
      }
      this.chipColorTmp = initVwCD2plmd00101.color
      if (this.saveCount > 0 && initVwCD2plmd00101.id < 0) {
        this.newEditMode = true
      }
      this.vwCD2plmd00101 = Object.assign({}, initVwCD2plmd00101)
      this.onSaveAction()
    },
    onSaveAction: function () {
      const tempKakuteiFlg = this.vwCD2plmd00101.kakuteiFlg
      const self = this
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.vwCD2plmd00101 = data.payload
            if (self.vwCD2plmd00101.juchuYmd) { self.vwCD2plmd00101.juchuYmd = filter.dateFormatter(self.vwCD2plmd00101.juchuYmd) }
            if (self.vwCD2plmd00101.sagyoYmd) { self.vwCD2plmd00101.sagyoYmd = filter.dateFormatter(self.vwCD2plmd00101.sagyoYmd) }
            if (self.vwCD2plmd00101.hatsuchiYmd) { self.vwCD2plmd00101.hatsuchiYmd = filter.dateFormatter(self.vwCD2plmd00101.hatsuchiYmd) }
            if (self.vwCD2plmd00101.hatsuchiHms) { self.vwCD2plmd00101.hatsuchiHms = (self.vwCD2plmd00101.hatsuchiHms).slice(0, 5) }
            if (self.vwCD2plmd00101.chakuchiYmd) { self.vwCD2plmd00101.chakuchiYmd = filter.dateFormatter(self.vwCD2plmd00101.chakuchiYmd) }
            if (self.vwCD2plmd00101.chakuchiHms) { self.vwCD2plmd00101.chakuchiHms = (self.vwCD2plmd00101.chakuchiHms).slice(0, 5) }
            if (self.vwCD2plmd00101.seikyuYoteiYmd) { self.vwCD2plmd00101.seikyuYoteiYmd = filter.dateFormatter(self.vwCD2plmd00101.seikyuYoteiYmd) }
            if (!self.vwCD2plmd00101.hatsuchiNm) { self.vwCD2plmd00101.hatsuchiNm = '' }
            if (!self.vwCD2plmd00101.chakuchiNm) { self.vwCD2plmd00101.chakuchiNm = '' }

            if (!self.vwCD2plmd00101.color) { self.vwCD2plmd00101.color = self.chipColorTmp }
            self.vwCD2plmd00101.kakuteiFlg = tempKakuteiFlg
            self.vwCD2plmd00101.newEditMode = self.newEditMode
            self.$emit('save', self.vwCD2plmd00101)
            if (self.continuousSaveMode) {
              self.vwCD2plmd00101.id = -1
              self.vwCD2plmd00101.trJuchuKihonId = -1
              self.vwCD2plmd00101.trJuchuMeisaiId = -1
              self.vwCD2plmd00101.juchuNo = ''
              self.tempVwCD2plmd00101 = Object.assign({}, self.vwCD2plmd00101)
            } else {
              self.$emit('close', undefined)
            }
            self.saveCount++
            self.newEditMode = false
            // self.continuousSaveMode = false
            resolve()
          })
        },
        getIdMethod: () => {
          return 0
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            // self.initBindVariables()
            // self.transition(0, { id: self.rec.vwJuchuKihon.id })
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        isNoMessageModeMethod: function () {
          return true
        },
        isUpdateModeMethod: function () {
          return true
        },
        isNoRefreshModeMethod: function () {
          return true
        }
      }
      this.register(opt)
    },
    registerPromise: function () {
      const f = this.HttpClient.post('/api/v1/VwCD2plmd00101/JuchuCreate', this.vwCD2plmd00101)
      return f
    },
    registerValidate: function () {
      var msg
      if (!this.vwCD2plmd00101.juchuYmd) {
        this.$refs.juchuYmd[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        return false
      }
      if (!this.vwCD2plmd00101.juchuEigyoshoId) {
        this.$refs.juchuEigyoshoId[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        return false
      }
      if (!this.vwCD2plmd00101.ninushiId) {
        this.$refs.ninushiId[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        return false
      }
      if (!this.vwCD2plmd00101.sagyoYmd) {
        this.$refs.sagyoYmd[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        return false
      }
      if (!this.vwCD2plmd00101.sagyoEigyoshoId) {
        this.$refs.sagyoEigyoshoId[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        return false
      }
      if (!this.vwCD2plmd00101.kamotsuKbn) {
        this.$refs.kamotsuKbn[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        return false
      }
      if (!this.vwCD2plmd00101.seikyuShashuSbt) {
        this.$refs.seikyuShashuSbt[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        return false
      }
      if (!this.vwCD2plmd00101.hatsuchiYmd) {
        this.$refs.hatsuchiYmd[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        return false
      }
      if (!this.vwCD2plmd00101.hatsuchiHms && this.isRequiredHms) {
        this.$refs.hatsuchiHms[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        return false
      }
      if (!this.vwCD2plmd00101.chakuchiYmd) {
        this.$refs.chakuchiYmd[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        return false
      }
      if (!this.vwCD2plmd00101.chakuchiHms && this.isRequiredHms) {
        this.$refs.chakuchiHms[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        return false
      }
      if (this.vwCD2plmd00101.hatsuchiYmd && this.vwCD2plmd00101.chakuchiYmd) {
        msg = validators.compareDate(this.vwCD2plmd00101.hatsuchiYmd, this.vwCD2plmd00101.chakuchiYmd)
        if (msg !== undefined) {
          this.$refs.hatsuchiYmd[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.chakuchiYmd[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
      }
      if (this.vwCD2plmd00101.hatsuchiYmd && this.vwCD2plmd00101.hatsuchiHms && this.vwCD2plmd00101.chakuchiYmd && this.vwCD2plmd00101.chakuchiHms) {
        msg = validators.compareDateTime(this.vwCD2plmd00101.hatsuchiYmd, this.vwCD2plmd00101.hatsuchiHms, this.vwCD2plmd00101.chakuchiYmd, this.vwCD2plmd00101.chakuchiHms)
        if (msg !== undefined) {
          this.$refs.hatsuchiYmd[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.hatsuchiHms[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.chakuchiYmd[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.chakuchiHms[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
      }
      if (this.vwCD2plmd00101.hatsuchiHms && this.vwCD2plmd00101.chakuchiHms && this.vwCD2plmd00101.hatsuchiYmd === this.vwCD2plmd00101.chakuchiYmd && this.vwCD2plmd00101.hatsuchiHms === this.vwCD2plmd00101.chakuchiHms) {
        this.$refs.hatsuchiHms[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0101', ['同日の発時刻', '同日の着時刻']))
        this.$refs.chakuchiHms[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0101', ['同日の発時刻', '同日の着時刻']))
        return false
      }
      if (this.vwCD2plmd00101.keiyakuHojoKbn === '1') {
        this.vwCD2plmd00101.hatsuchiBiko = null
        this.vwCD2plmd00101.chakuchiBiko = null
      }
      return true
    },
    // ----------------------------------------------------------------------------------------------------
    // 請求予定年月日初期値取得
    // ----------------------------------------------------------------------------------------------------
    inputYmd: function () {
      if (this.vwCD2plmd00101.keijobiKbn !== undefined) {
        if (this.vwCD2plmd00101.keijobiKbn === '1' && this.vwCD2plmd00101.hatsuchiYmd !== null && this.vwCD2plmd00101.hatsuchiYmd !== '' && this.vwCD2plmd00101.hatsuchiYmd !== undefined) {
          this.$set(this.vwCD2plmd00101, 'seikyuYoteiYmd', this.vwCD2plmd00101.hatsuchiYmd)
        } else if (this.vwCD2plmd00101.keijobiKbn === '2' && this.vwCD2plmd00101.chakuchiYmd !== null && this.vwCD2plmd00101.chakuchiYmd !== '' && this.vwCD2plmd00101.chakuchiYmd !== undefined) {
          this.$set(this.vwCD2plmd00101, 'seikyuYoteiYmd', this.vwCD2plmd00101.chakuchiYmd)
        }
      }
    },
    dispSwitchControl: function () {
      this.hatsuchiSwitch = Boolean(!this.vwCD2plmd00101.hatsuchiId && this.vwCD2plmd00101.hatsuchiBiko)
      this.chakuchiSwitch = Boolean(!this.vwCD2plmd00101.chakuchiId && this.vwCD2plmd00101.chakuchiBiko)
      this.expandKeiyuchi = Boolean(this.vwCD2plmd00101.keiyuchiId2 || this.vwCD2plmd00101.keiyuchiId2Biko || this.vwCD2plmd00101.keiyuchiId3 || this.vwCD2plmd00101.keiyuchiId3Biko || this.vwCD2plmd00101.keiyuchiId4 || this.vwCD2plmd00101.keiyuchiId4Biko || this.vwCD2plmd00101.keiyuchiId5 || this.vwCD2plmd00101.keiyuchiId5Biko)
      this.keiyakuHojoKbnChange()
    },
    keiyakuHojoKbnChange: function () {
      if (this.vwCD2plmd00101.keiyakuHojoKbn === '1') {
        this.hatsuchiSwitch = false
        this.chakuchiSwitch = false
        this.switchReadonly = true
      } else {
        this.switchReadonly = false
      }
    },
    onSwitchingHatsuchiCodeToBiko: function () {
      this.hatsuchiSwitch = !this.hatsuchiSwitch
    },
    onSwitchingChakuchiCodeToBiko: function () {
      this.chakuchiSwitch = !this.chakuchiSwitch
    },
    // --------------------------------------------------------------------------------
    // 経由地展開
    // --------------------------------------------------------------------------------
    onExpandKeiyuchi: function () {
      this.expandKeiyuchi = !this.expandKeiyuchi
    },
    // --------------------------------------------------------------------------------
    // カラーリセット
    // --------------------------------------------------------------------------------
    onUndoChipColor: function () {
      this.vwCD2plmd00101.color = this.chipColorTmp
    },
    // --------------------------------------------------
    // IndexedDB取得
    // --------------------------------------------------
    getTeikeiInfo: function (teikeiCourseNo) {
      var teikeiCourse = this.teikeiCourseList.find((t) => {
        return t.teikeiCourseNo === teikeiCourseNo
      })
      return teikeiCourse
    }
  }
}
